// custom typefaces
import "typeface-montserrat"
import "typeface-merriweather"

import "prismjs/themes/prism-okaidia.css"

import "./src/styles/global.css"
